module.exports = __webpack_public_path__ + "img/icon-renegades-le_rfu.630d649.png";